import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);

const state = {
    lang: 'cn',	// cn:中文；en:英文；mm:缅甸文
    langMap: {
        'cn':{
            'index1':'答题准备',
            'index2':'Everyone would get random',
            'index3':'Answer correct would get 10',
            'index4':'Need to finish the answering',
            'index5':'Points could be redeemed',
            'index6':'More points would get more',
            'index7':'准备好了，开始答题',

            'ucenter1':'我的积分',
            'ucenter2':'我兑换的礼物券',
            'ucenter3':'兑换',
            'ucenter4':'成功兑换抽奖码，请等待开奖',

            'answer1':'提交答案',
            'answer2':'继续下一题',
            'answer3':'你没有获取积分',

            'end1':'本次答题总时间',
            'end2':'总共获得积分',
            'end3':'积分兑换抽奖机会',
            'end4':'分享',
            'end5':'我在这里答题，不服来战',

            'login1':'请输入您的手机号码和密码进行注册',
            'login2':'手机号码',
            'login3':'输入密码',
            'login4':'登录',
            'login5':'点击这里',
            'login6':'没有账号？',
            'login7':'or Type 10toMio send sms to 1234',
            'login8':'忘记密码？',

            'mygift1':'我的兑换券',
            'mygift2':'没有兑换记录',
            'mygift3':'未开奖',
            'mygift4':'未中奖',
            'mygift5':'中奖',

            'share1':'本次答题总时间:',
            'share2':'总共获得积分:',
            'share3':'我来挑战',

            'footer1':'客服电话',

            'btn1':'确定',
        },
        'en':{
            'index1':'questions',
            'index2':'Everyone would get random',
            'index3':'Answer correct would get 10',
            'index4':'Need to finish the answering',
            'index5':'Points could be redeemed',
            'index6':'More points would get more',
            'index7':'Ready to begin',

            'ucenter1':'My Score',
            'ucenter2':'My Redeem',
            'ucenter3':'Redeem',
            'ucenter4':'success, please wait for the lottery',

            'answer1':'Submit',
            'answer2':'Next Question',
            'answer3':'You didn’t get points',

            'end1':'Total cost time',
            'end2':'Total get points',
            'end3':'Points redemption lucky Draw',
            'end4':'Share',
            'end5':'Challenge together',

            'login1':'Please enter your cell phone number and pasword for registration',
            'login2':'cellphone number',
            'login3':'enter password',
            'login4':'login',
            'login5':'Click here',
            'login6':'Don’t have Account?',
            'login7':'or Type 10toMio send sms to 1234',
            'login8':'Forget your password?',

            'mygift1':'My voucher',
            'mygift2':'No redemption record',
            'mygift3':'No lottery',
            'mygift4':'Not winning',
            'mygift5':'Winning',

            'share1':'The total answer time',
            'share2':'Get points in total',
            'share3':'I challenge',

            'footer1':'Call Center',

            'btn1':'confirm',
        },
        'mm':{
            'index1':'က၏း္န္း က္ု္ကၚု္ ကန႔မွတု္ၚေ္းကငဖ ၚု္ြႏု္ၚေ္ ည',
            'index2':'္esူမွတtioု္ၚေn္းsကခ ၏္းက၏း္န္း၏ခ္း္္ၚ၏့္၏ည္',
            'index3':'oinကtsငဖ၏ရန္ကန္ ါက ကဒ၏ရမွတ္္္ၚရ ါ၏ည္ ကဒေကစန္႔ မွတေ္း ကငဖက',
            'index4':'င း ု္ရးက ္ေ္ကငဖ ၚု္္န္္ၚု္ ါ ည',
            'index5':'ew္၏aခ္rdးကs ၚု္ ု္၏ခ္း၏ရက္းြႏု္မွတ္ပ ယူြႏု္ၚေ္ ည္ ၏ရမွတ္ ၏ခ္း ရု္း ည္ ြႏၚု္ေ္ ု္ကၚု္',
            'index6':'္ယူ္န္ ္ေ့္က္း ၏ခ္း ရု္းငဖေ္ ည',
            'index7':'အဆင်သင့်, အဖြေစတင်',

            'ucenter1':'ကၽြႏု္္ ္ပ္၏ရမွတ္',
            'ucenter2':'ကၽြႏု္္ ္ပ္က္က ္ေ္ကင္က္္ခ္',
            'ucenter3':'္က္က ္ေ္ကင္က္္ခ္',
            'ucenter4':'အောင်မြင်သောထီကိုရွေးနှုတ်သောကုဒ်, ထီစောင့်ဆိုင်းပါ',

            'answer1':'မွတေ္ ေ္း ည္',
            'answer2':'ကန္က္က၏း္န္းမွတေ္္ု္',
            'answer3':'ေ္ ၏ရမွတ္၏္္ရၚ့္ ါ',

            'end1':'ဖြေဆိုရန်စုစုပေါင်းအချိန်',
            'end2':'္၏ရမွတ္ေု္ေု္က ါေ္း',
            'end3':'္၏ရမွတ္၏ခ္းက္းြႏု္မွတ္ထ္း ည့္ကရေ၏္း၏',
            'end4':'က ေု္',
            'end5':'အတူတူစိန်ခေါ်မှုများ',

            'login1':'မှတ်ပုံတင်အဘို့သင့်ဆဲလ်ဖုန်းနံပါတ်ကိုနှင့် password ကိုရိုက်ထည့်ပေးပါ',
            'login2':'ဖုန်းနံပါတ်',
            'login3':'စကားဝှက်ကိုရိုက်ထည့်ပါ',
            'login4':'အတွက် Log',
            'login5':'ဤနေရာကိုကလစ်နှိပ်ပါ',
            'login6':'အကောင့်ရှိသည်မဟုတ်လော',
            'login7':'or Type 10toMio send sms to 1234',
            'login8':'သင့်ရဲ့စကားဝှက်ကိုမေ့သွားတယ်?',

            'mygift1':'ငါ၏အကူပွန်',
            'mygift2':'အဘယ်သူမျှမလဲလှယ်စံချိန်',
            'mygift3':'အဘယ်သူမျှမထီ',
            'mygift4':'အနိုင်ရမရ',
            'mygift5':'အနိုင်ရ',

            'share1':'ဖြေဆိုရန်စုစုပေါင်းအချိန်:',
            'share2':'စုစုပေါင်းရမှတ်ခုနှစ်တွင်',
            'share3':'ငါစိန်ခေါ်ပါလိမ့်မယ်',

            'footer1':'ဖု္န္းက္ေ ၚု္က ္ေေ္မွတ္',

            'btn1': 'သတ်မှတ်'
        }
    }
};

export default new Vuex.Store({
    state,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/store/index.js